import "./App.css";

import Search from "./Search";
import Footer from "./Footer";

function App() {
  return (
    <div className="App">
      <div className="Container">
        <Search />
        <Footer />
      </div>
    </div>
  );
}

export default App;
